module.exports = __webpack_public_path__ + "static/Orkney-Medium-ddb46884b03e94a84fd85ded0acf44bc.woff2";